module.exports = __webpack_public_path__ + "img/docasny.08f14ade.jpg";